export const AssistantSetAsPublic = "Your Assistant is now public";
export const AssistantSetAsPrivate = "Your assistant is now private";
export const AssistantNeedToActiveFirst = "First you need to activate the assistant";
export const AssistantAddedToFeaturedList = "Assistant added into featured list";
export const AssistantRemovedFromFeaturedList = "Assistant removed from featured list";
export const AssistantAddedToPinnedList ="Added to your Pinned list";
export const AssistantAlreadyInPinnedList ="It's already in your Pinned List";
export const AssistantFailedToAddToPinList = "Assistant adding failed.";
export const AssistantRemovedFromPinnedList = "Removed from your Pinned list";